import React, { useState } from "react";

interface ChangePasswordProps {
  onBack: () => void;
  onPasswordUpdate: (oldPwd: string, newPwd: string, confirmPwd: string) => void;
  pwdMessage: string;
  onClose: () => void; // <-- this is passed from Dashboard
}

const ChangePassword: React.FC<ChangePasswordProps> = ({
  onBack,
  onPasswordUpdate,
  pwdMessage,
  onClose, // <-- destructure here
}) => {
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [localError, setLocalError] = useState("");

  // Show/hide states
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleUpdate = () => {
    setLocalError("");

    if (!oldPwd || !newPwd || !confirmPwd) {
      setLocalError("Fill the required fields");
      return;
    }
    if (newPwd.length < 6) {
      setLocalError("New password must be at least 6 characters.");
      return;
    }
    if (newPwd !== confirmPwd) {
      setLocalError("New password and Confirm password do not match.");
      return;
    }
    if (oldPwd === newPwd) {
    setLocalError("New password must be different from old password.");
    setOldPwd("");
    setNewPwd("");
    setConfirmPwd("");
    return;
  }

    onPasswordUpdate(oldPwd, newPwd, confirmPwd);
    setOldPwd("");
    setNewPwd("");
    setConfirmPwd("");
  };

  return (
    <div className="change-password">
      <div className="panel-header">
        <i className="fas fa-arrow-left back-icon" onClick={onBack}></i>
        <h4 className="panel-title text-center">Change Password</h4>
      </div>

      {/* Old Password */}
      <div className="pwd-wrapper">
        <input
          type={showOld ? "text" : "password"}
          placeholder="Old Password"
          value={oldPwd}
          onChange={(e) => setOldPwd(e.target.value)}
          className="pwd-input"
        />
        <span className="pwd-toggle" onClick={() => setShowOld(!showOld)}>
          <i className={showOld ? "fas fa-eye-slash" : "fas fa-eye"}></i>
        </span>
      </div>

      {/* New Password */}
      <div className="pwd-wrapper">
        <input
          type={showNew ? "text" : "password"}
          placeholder="New Password"
          value={newPwd}
          onChange={(e) => setNewPwd(e.target.value)}
          className="pwd-input"
        />
        <span className="pwd-toggle" onClick={() => setShowNew(!showNew)}>
          <i className={showNew ? "fas fa-eye-slash" : "fas fa-eye"}></i>
        </span>
      </div>

      {/* Confirm Password */}
      <div className="pwd-wrapper">
        <input
          type={showConfirm ? "text" : "password"}
          placeholder="Confirm Password"
          value={confirmPwd}
          onChange={(e) => setConfirmPwd(e.target.value)}
          className="pwd-input"
        />
        <span className="pwd-toggle" onClick={() => setShowConfirm(!showConfirm)}>
          <i className={showConfirm ? "fas fa-eye-slash" : "fas fa-eye"}></i>
        </span>
      </div>

      {(localError || pwdMessage) && (
        <p className="pwd-message">{localError || pwdMessage}</p>
      )}

      <div className="password-btn">
        <button className="submit-btn" onClick={handleUpdate}>
          Update Password
        </button>
      </div>
    </div>
  );
};

export default ChangePassword;
